module.exports = new __parcel__URL__("agree.863885d7.png").toString();